// extracted by mini-css-extract-plugin
module.exports = {"signup-form":"Signup_signup-form__1z5Fe"};